<div class="section">
    <div class="headerSection">
        <div *ngIf="section.SectionTitle" class="header">{{section?.SectionTitle}}</div><!-- section header -->
        <div *ngIf="section.Subtitle" class="header">{{section?.Subtitle}}</div><!-- section header -->
    </div>
    <div class="section-body">
        <ng-container *ngFor="let item of children" [appRenderNode]="item"></ng-container>
    </div>
</div>
